module.exports = __webpack_public_path__ + "static/media/spotifyLink.e5ab2b59.png";